module.exports = __webpack_public_path__ + "assets/img/post-title.dd1cb440.svg";